/**
 * Normalizes the GET /intakeforms response to an array.
 *
 * The generated contract types the response as a bare array, but the backend actually returns
 * an `{ IntakeForms: [...] }` wrapper (the generated spec is incomplete). The two disagree, so
 * accept either shape. Returns `unknown[]` because the runtime shape is not guaranteed by the
 * (incorrect) generated type; consumers read the fields they need.
 *
 * Shared by `useIntakeForms` (management list) and `useIntakeFormTemplates` (new/view service).
 */
export const extractIntakeFormsList = (data: unknown): unknown[] => {
  if (Array.isArray(data)) {
    return data
  }
  if (data && typeof data === 'object' && 'IntakeForms' in data && Array.isArray(data.IntakeForms)) {
    return data.IntakeForms
  }
  return []
}
